import { RemoteAuthenticationChangePassword } from 'data/usecases';
import { AuthenticationChangePasswordUseCaseInterface } from 'domain/usecases';
import { makeApiUrlResetPassword } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthenticationChangePassword =
  (): AuthenticationChangePasswordUseCaseInterface => {
    return new RemoteAuthenticationChangePassword(
      makeApiUrlResetPassword(),
      makeAxiosHttpClient(),
    );
  };
